<style scoped>

  .logo {
    width: 120px !important;
    height: 70px !important;
  }

</style>

<template>

  <div id="sidebar" class="ui left vertical sidebar large menu" :class="{ inverted: $isStaging }">

    <div class="item clickable" @click="navTo('/')">
      <img class="ui centered image logo" src="/assets/images/logo.png">
    </div>

    <div v-if="$isStaging" class="item centered">      
      <div class="header">
        <div class="ui large red label" style="margin-bottom: -10px !important;">
          Ambiente de Testes
        </div>
      </div>
    </div>     

    <div class="item">
      <div v-if="$store.state.auth.user" class="header">{{ $store.state.auth.user.name }}</div>
      <div class="menu">
        <menu-item :active="isHomePage" route="/" label="Página Inicial" />
        <menu-item :active="isProfilePage" route="/profile" label="Perfil" />
        <a class="item" @click="onLogout()">Sair</a>
      </div>
    </div>

    <div v-if="$isMobile && $store.state.auth.bookmarks.length > 0" class="item">    
      <div class="header">Favoritos</div>
      <div class="menu">
        <menu-item v-for="(bookmark, index) in $store.state.auth.bookmarks" :key="index"
          :active="$route.path.includes(bookmark.route)" :route="bookmark.route" :label="bookmark.label" />
      </div>            
    </div>

    <div v-if="$isAdmin()" class="item">    
      <div class="header">Administração</div>
      <div class="menu">
        <menu-item :active="isSettingsPage" route="/admin/settings" label="Configurações" />
        <menu-item :active="isUsersPage" route="/admin/users" label="Usuários" />
        <menu-item :active="isUserGroupsPage" route="/admin/user-groups" label="Grupos de Usuários" />
        <menu-item :active="isNotesPage" route="/admin/notes" label="Recados" />
      </div>            
    </div>

    <div v-if="$isSimavet()" class="item">      
      <div class="header">Cadastros</div>
      <div class="menu">          
        <menu-item :active="isCustomersPage" route="/entries/customers" label="Clínicas" />
        <menu-item :active="isVetsPage" route="/entries/vets" label="Veterinários" />
        <menu-item :active="isSpeciesPage" route="/entries/species" label="Espécies" />
        <menu-item :active="isRacesPage" route="/entries/races" label="Raças" />
        <menu-item :active="isOwnersPage" route="/entries/owners" label="Tutores" />
        <menu-item :active="isAnimalsIndexPage" route="/entries/animals" label="Animais" />
        <menu-item :active="isAnimalRegistrationsPage" route="/entries/animal-registrations" label="Fichas Cadastrais" />
        <menu-item :active="isOrgansPage" route="/entries/organs" label="Órgãos" />
        <menu-item :active="isCertTemplatesPage" route="/entries/cert-templates" label="Modelos de Laudos" />
        <menu-item :active="isExamTypesPage" route="/entries/exam-types" label="Tipos de Exames" />
        <menu-item :active="isServicesPage" route="/entries/services" label="Serviços" />
      </div>            
    </div>

    <div v-if="$isSimavet()" class="item">      
      <div class="header">Processos</div>
      <div class="menu">
        <menu-item :active="isExamRequestsPage" route="/procs/exam-requests" label="Solicitações de Exames" />
        <menu-item :active="isCertsPage" route="/procs/certs" label="Laudos" />
        <menu-item :active="isCertComplementRequestsPage" route="/procs/cert-complement-requests" label="Solicitações de Complemento" />
      </div>            
    </div>

    <div v-if="$isSimavet()" class="item">    
      <div class="header">Financeiro</div>
      <div class="menu">
        <menu-item :active="isFinancialDailyCertsPage" route="/financial/daily-certs" label="Laudos por Dia" />
        <menu-item :active="isFinancialPendingCertsPage" route="/financial/pending-certs" label="Laudos Pendentes" />
        <menu-item :active="isFinancialEmployeeCertsPage" route="/financial/employee-certs" :label="$isAdmin() ? 'Laudos de Colaboradores' : 'Meus Laudos'" />
        <menu-item v-if="$isAdmin()" :active="isCertAnticipationsPage" route="/financial/cert-anticipations" label="Antecipações de Laudos" />
        <menu-item v-if="$isAdmin()" :active="isFinancialNaturesPage" route="/financial/natures" label="Naturezas" />
        <menu-item v-if="$isAdmin()" :active="isSuppliersPage" route="/financial/suppliers" label="Fornecedores" />
        <menu-item v-if="$isAdmin()" :active="isCustomerInvoicesPage" route="/financial/customer-invoices" label="Fechamentos de Clientes" />
        <menu-item :active="isEmployeeInvoicesPage" route="/financial/employee-invoices" :label="$isAdmin() ? 'Fechamentos de Colaboradores' : 'Meus Fechamentos'" />
        <menu-item v-if="$isAdmin()" :active="isReceivablesPage" route="/financial/receivables" label="Títulos a Receber" />
        <menu-item v-if="$isAdmin()" :active="isPayablesPage" route="/financial/payables" label="Títulos a Pagar" />
      </div>            
    </div>

    <menu-item v-if="$isVet()" :active="isExamRequestsPage" route="/procs/exam-requests" label="Solicitações de Exames" />
    
    <menu-item v-if="!$isSimavet()" :active="isCertsPage" route="/procs/certs" label="Laudos" />

    <menu-item v-if="!$isSimavet()" :active="isAnimalRegistrationsPage" route="/entries/animal-registrations" label="Fichas Cadastrais" />

  </div>

</template>

<script>

  import isPageMixin from "@/mixins/ispage"
  import MenuItem from "./menu-item.vue"

  export default {

    name: "SideMenu",

    mixins: [isPageMixin],

    components: {
      MenuItem,
    },

    mounted() {
      $("#sidebar").sidebar()
    },

    methods: {

      navTo(route) {

        $("#sidebar").sidebar("hide")

        this.$router.push(route)
      },

      hideSideBar() {
        $("#sidebar").sidebar("hide")
      },

      onLogout() {
        this.$emit("onLogout")
      },
    },

  }


</script>
